import React from 'react'
import MaskedInput from 'react-text-mask';
import { Button, Col, FormGroup, FormText, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { Dialog } from 'primereact/dialog';
import { AlertTriangle } from "react-feather";



export const ModalCancelInvoice = (props) => {
    console.log("🚀 ~ ModalCancelInvoice ~ props:", props)

    const {
        modalCancellation, toggleModalCancellation,
        loading,

        informationInvoice, ListTypeCancellations,
        code_type_cancellation, code_reference_value,
        handleInputChange, SaveCancellationInvoice,
        message, handleClosedMessage, _url_helen, insan,
        isGeneral

    } = props;

    console.log("insan", isGeneral);




    return (
        <Dialog
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-trash"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Cancelación de cfdi

                            </div>
                        </div>
                    </div>
                </div>
            }
            visible={modalCancellation}
            maskClassName="custom-total-mask"
            onHide={toggleModalCancellation}
            className={message ? "seller-dialog seller-dialog seller-danger seller-medium" : "seller-dialog seller-dialog seller-danger seller-large"}
            footer={
                <div className={!message ? "" : "d-none"
                } >
                    <Button size='sm' color='danger' type='button' disabled={loading} className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""} onClick={SaveCancellationInvoice}>
                        Cancelar factura
                    </Button>
                    <Button size='sm' color='secondary' type='button' onClick={toggleModalCancellation}>
                        Cerrar
                    </Button>

                </div >
            }
            closable={false}

        >
            {
                (
                    message &&
                    (
                        _url_helen !== insan || !informationInvoice.isGeneralPublic
                    )
                ) && (
                    <Col sm="12" className="pt-1">
                        <Col sm="12" className='pl-0 pr-0 pt-2' >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "15px",
                                marginBottom: "15px"
                            }}>
                                <div style={{
                                    backgroundColor: "#ffe6e6",
                                    borderRadius: "50%",
                                    width: "70px",
                                    height: "60px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <AlertTriangle
                                        size={28}
                                        color="#c92a2a"
                                        style={{ display: "block" }}
                                    />
                                </div>
                                <div>
                                    <p
                                        className="mb-0"
                                        style={{
                                            fontSize: "13px",
                                            color: "#0d3b59"
                                        }}
                                    >
                                        La factura no puede ser cancelada debido a que ha superado el periodo permitido de un mes desde su emisión.
                                    </p>
                                </div>
                            </div>
                            <div
                                style={{
                                    color: "#856404",
                                    fontSize: "0.78rem",
                                    marginTop: "6px",
                                    fontWeight: "500",
                                    backgroundColor: "#fff3cd",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #ffeeba",
                                }}
                            >
                                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                Sera necesario realizar una nota de credito.
                            </div>
                        </Col>
                        <Col sm="12" className='p-l-0 p-r-0' >
                            <Row>
                                <Col sm="5">
                                </Col>
                                <Col sm="7" className='pl-0 pr-0 pt-5' style={{ textAlign: "right" }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        width: "100%"
                                    }}>
                                        <Button
                                            size="sm"
                                            color='danger'
                                            style={{ flex: 1 }}
                                            onClick={() => handleClosedMessage()}
                                        >
                                            Cancelar factura
                                        </Button>

                                        <Button
                                            size="sm"
                                            color="secondary"
                                            type="button"
                                            style={{ flex: 1 }}
                                            onClick={toggleModalCancellation}
                                        >
                                            Regresar
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Col>)
            }

            {
                message && (_url_helen === insan && informationInvoice.isGeneralPublic) &&

                <div
                    style={{
                        background: "#fff5f5",
                        border: "1px solid #f5c2c7",
                        borderRadius: "12px",
                        padding: "16px",
                        marginTop: "10px",
                        boxShadow: "0 2px 8px rgba(220,53,69,0.08)"
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "12px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #f5c2c7"
                        }}
                    >
                        <i
                            className="fa fa-exclamation-triangle"
                            style={{
                                color: "#dc3545",
                                fontSize: "1.3rem"
                            }}
                        />

                        <div>
                            <div
                                style={{
                                    fontWeight: "600",
                                    color: "#842029",
                                    fontSize: "1rem"
                                }}
                            >
                                No se puede realizar esta acción.
                            </div>

                            <small
                                style={{
                                    color: "#6c757d"
                                }}
                            >
                                Ya paso más de un mes de emisión, para que se pueda cancelar.
                            </small>
                        </div>
                    </div>

                    <Col sm="12" style={{ textAlign: "center" }}>
                        <img
                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                            style={{
                                width: "45%",
                                marginBottom: "15px"
                            }}
                            alt="Sin Muestras"
                        />
                    </Col>

                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            border: "1px solid #f1d5d8",
                            overflow: "hidden"
                        }}
                    >

                        <div
                            style={{
                                padding: "10px 15px",
                                background: "#fff8f8",
                                borderBottom: "1px solid #f1d5d8",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontWeight: "600",
                                color: "#842029"
                            }}
                        >
                            <i className="pi pi-shield"></i>
                            Factura Global
                        </div>



                    </div>

                </div>
            }

            {
                !message && <Col am="12" className='p-l-0 p-r-0' >
                    <Row>
                        <Col sm="12" md="12" lg="12">
                            <div
                                style={{
                                    color: "#856404",
                                    fontSize: "0.78rem",
                                    marginTop: "6px",
                                    fontWeight: "500",
                                    backgroundColor: "#fff3cd",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #ffeeba",
                                }}
                            >
                                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                Estas intentando eliminar el siguiente CFDI
                            </div>                        </Col>
                    </Row>
                    <Row className='pt-3' >
                        <Col sm="12" md="12" lg="12">
                            {
                                informationInvoice.rfcReceptor !== undefined && <>
                                    <Row className='m-b-1'>
                                        <Col sm="12" md="5" lg="5">
                                            <label style={{ fontSize: "12px", color: "#002940" }} ><b>Razón social</b></label> <br />
                                            <label>{informationInvoice.commercialName}</label>
                                        </Col>
                                        <Col sm="12" md="3" lg="3">
                                            <label><b style={{ fontSize: "12px", color: "#002940" }} >RFC</b></label> <br />
                                            <label>{informationInvoice.rfcReceptor}</label>
                                        </Col>

                                        <Col sm="12" md="3" lg="3">
                                            <label><b style={{ fontSize: "12px", color: "#002940" }} >Fecha de emisión</b></label> <br />
                                            <label>{informationInvoice.dateCreated}</label>
                                        </Col>
                                    </Row>
                                    <Row className='m-b-1'>
                                        <Col sm="4" md="5" lg="5">
                                            <label><b style={{ fontSize: "12px", color: "#002940" }} >Folio fiscal</b></label><br />
                                            <label>{informationInvoice.uuid}</label>
                                        </Col>
                                        <Col sm="12" md="3" lg="3">
                                            <label><b style={{ fontSize: "12px", color: "#002940" }} >Serie y folio</b></label> <br />
                                            <label>{informationInvoice.serieFolio}</label>
                                        </Col>

                                        <Col sm="12" md="3" lg="3">
                                            <label><b style={{ fontSize: "12px", color: "#002940" }}>Total</b></label> <br />
                                            <label>{informationInvoice.codeCoin + " " + informationInvoice.total}</label>
                                        </Col>
                                    </Row>

                                </>
                            }
                        </Col>
                    </Row>
                    <Row className='pt-4' >
                        <Col sm="12" md="12" lg="12">
                            <FormGroup>
                                <b className='f-w-600' style={{ color: "#002940", fontSize: "12px" }} >Ingresa el método de cancelación <span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
                                <Input type='select' className='form-control form-control-sm input-air-primary b-r-9' name='code_type_cancellation' value={code_type_cancellation} onChange={handleInputChange}>
                                    <option value={"0"}>Selecciona una opción</option>
                                    {
                                        ListTypeCancellations.length > 0 && ListTypeCancellations.map(_cancellation => {
                                            return <option key={_cancellation.code} value={_cancellation.code}>{_cancellation.description}</option>
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        code_type_cancellation === "01" && <Row>
                            <Col sm="12" md="12" lg="12">
                                <b className='f-w-600' style={{ color: "#002940", fontSize: "12px" }} >Ingresa el folio fiscal de la nueva factura relacionada <span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
                                <MaskedInput
                                    mask={[
                                        /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, '-', /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, '-', /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, '-', /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, '-', /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/, /[0-9 A-Z]/
                                    ]}
                                    className='form-control form-control-sm input-air-primary b-r-9'
                                    placeholder='________-____-____-____-____________'
                                    name="code_reference_value"
                                    value={code_reference_value}
                                    guide={true}
                                    keepCharPositions={true}
                                    onChange={(e) => handleInputChange(e)}
                                />
                                <FormText color='primary' className='f-b-700'>INGRESA SOLO NUMEROS Y LETRAS EN MAYUSCULAS</FormText>
                            </Col>
                        </Row>
                    }
                </Col>
            }

        </Dialog >
    )
}